/** Mensaje cuando un invitado intenta entrar y la sesión ya terminó */
export const SESSION_ENDED_INVITADO_MESSAGE =
  'La sesión a la que está intentando ingresar ya ha finalizado'

/**
 * Detecta respuestas típicas de API cuando la sesión ya no está abierta.
 */
export function isSessionEndedForGuestResponse(apiMessage, payload = {}) {
  if (payload.sessionOpen === false) return true
  if (payload.isSessionOpen === false) return true
  if (payload.sessionIsOpen === false) return true
  if (!apiMessage || typeof apiMessage !== 'string') return false
  const m = apiMessage.toLowerCase()
  return (
    m.includes('finaliz') ||
    m.includes('cerrad') ||
    m.includes('cerró') ||
    m.includes('closed') ||
    m.includes('ended') ||
    m.includes('no está activa') ||
    m.includes('ya no está') ||
    m.includes('no disponible')
  )
}

export function messageForGuestSessionAccess(apiMessage, payload = {}) {
  if (isSessionEndedForGuestResponse(apiMessage, payload)) {
    return SESSION_ENDED_INVITADO_MESSAGE
  }
  return typeof apiMessage === 'string' ? apiMessage : ''
}
